import { PAYRUNS_SUMMARY_YEAR_FETCHING, PAYRUNS_SUMMARY_YEAR_SUCCESS, PAYRUNS_SUMMARY_YEAR_FAILED } from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case PAYRUNS_SUMMARY_YEAR_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case PAYRUNS_SUMMARY_YEAR_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case PAYRUNS_SUMMARY_YEAR_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
};
